/// <amd-module name="Test/common-util/TestResults.Filtering.Common" />
import { localeIgnoreCaseComparer, equals } from "VSS/Core/Util/String";

import * as Resources from "Test/common-util/Resources";
import { FilterState, FilterValue } from "Test/common-util/Contracts/Filters";

export class FilterValueItem {
    constructor(value: string | number | boolean, displayValue?: string) {
        this.value = value;
        this.displayValue = displayValue;
    }

    value: string | number | boolean;
    displayValue?: string;
}


export function areFilterStatesEqual(filterState1: FilterState, filterState2: FilterState): boolean {

    if (filterState1 == null && filterState2 == null) {
        return true;
    }
    else if (filterState1 == null) {
        return false;
    }
    else if (filterState2 == null) {
        return false;
    }

    //This handles both null and empty
    if (Object.keys(filterState1).length == 0 && Object.keys(filterState2).length == 0) {
        return true;
    } 
    else if (Object.keys(filterState1).length == 0 || Object.keys(filterState2).length == 0) {
        return false;
    }

    let keys1 = Object.keys(filterState1).sort();
    let keys2 = Object.keys(filterState2).sort();
    if (!equals(JSON.stringify(keys1), JSON.stringify(keys2))) {
        return false;
    }
    for (let key in filterState1) {
        if (key in filterState2) {
            let values1 = filterState1[key].values.sort(filterValueItemComparator);
        
            let values2 = filterState2[key].values.sort(filterValueItemComparator);

            if (!equals(JSON.stringify(values1), JSON.stringify(values2))) {
                return false;
            }

            let options1 = filterState1[key].options;
            let options2 = filterState2[key].options;
            if (!equals(JSON.stringify(options1), JSON.stringify(options2))) {
                return false;
            }
        }
    }
    return true;
}

export function getDisplayValue(filterValueItem: FilterValueItem): string {
    if (filterValueItem.displayValue === undefined && filterValueItem.value) {
        return filterValueItem.value.toString();
    }
    else if (filterValueItem.displayValue) {
        return filterValueItem.displayValue;
    }

    return Resources.UnspecifiedText;
}

export function sortFilterState(filterState: FilterState) {
    if (!filterState) {
        return filterState;
    }

    for (let key in filterState) {
        let sortedFilterValues = filterState[key].values.sort(filterValueItemComparator);

        filterState[key].values = sortedFilterValues;
    }
}

function filterValueItemComparator(a: FilterValue, b: FilterValue) {
    return localeIgnoreCaseComparer(getStringFromFilterValue(a), getStringFromFilterValue(b)); 
}

 function getStringFromFilterValue(filterValue: FilterValue): string {
    if (!filterValue) {
        return Resources.UnspecifiedText;
    }
    else if (filterValue instanceof FilterValueItem) {
        return getDisplayValue(filterValue);
    }
    
    return filterValue.toString();
}
